import {
  awaitedSteps,
  openChatPrepare,
  optimisesAtOnce,
  type PrepareStep,
} from "@/features/advice-portal/lib/chat-prepare";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareAdvisoryArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  awaitingResult,
  clientIdTakenAsQuery,
  handedOverResult,
} from "@/features/intelligence/lib/tool-result";

export function prepareAdvisory(
  { seed, ignored, notAnId }: PrepareAdvisoryArgs,
  toolCallId: string,
): HandlerOutcome {
  openChatPrepare(toolCallId, seed);
  const awaited = awaitedSteps(seed);
  const starts = optimisesAtOnce(seed);
  if (awaited.length === 0) {
    return handedOverResult(`the advisory; ${starts ? RUNS : RUNS_NOTHING}`, ignored);
  }
  return awaitingResult(
    clientIdTakenAsQuery(
      `Cards are shown in the chat for: ${awaited.map((step) => STEP_LABEL[step]).join(", ")}`,
      seed,
      notAnId,
      "the Kund card asks the advisor who the client is",
    ),
    `${NOTHING_YET}; once the advisor answers them, ${starts ? STARTS : WAITS}`,
    "points to the cards; do not list the steps, do not ask for them in text, and do not say " +
      "the advisory is opened",
    ignored,
  );
}

const STARTS =
  "the card goes straight to the optimisation from the amount the message gave and runs one " +
  "optimisation and two analyses in Quant, which are stored and cannot be deleted, unless " +
  "Förutsättningar stops it with an error such as a withdrawal above the portfolio value";

const WAITS =
  "the advisory waits on Förutsättningar, since no amount from the message was kept, and the " +
  "optimisation is the advisor's click";

const RUNS = `on this call ${STARTS}`;

const RUNS_NOTHING = `nothing runs in Quant on this call: ${WAITS}`;

const NOTHING_YET = "Nothing is opened and nothing has run in Quant on this call";

const STEP_LABEL: Record<PrepareStep, string> = {
  client: "Kund",
  portfolio: "Portfölj",
  meeting: "Rådgivningens utförande",
  start: "Så här börjar du",
};
